import Vue from 'vue';
import ModalWithBackground from '@/components/Reusables/ModalWithBackground';
import AvatarTooltiped from '@/components/Reusables/AvatarTooltiped';
import SelectUser from '@/components/Reusables/SelectUser';

/* GLOBAL COMPONENTS */
Vue.component('ModalWithBackground', ModalWithBackground.default || ModalWithBackground);
Vue.component('AvatarTooltiped', AvatarTooltiped.default || AvatarTooltiped);
Vue.component('SelectUser', SelectUser.default || SelectUser);
